module.exports = __webpack_public_path__ + "images/brooklyn-d3fc8864b05c4cc16f7240bca252731c.jpg";